export default __webpack_public_path__ + "static/media/1864.fdb6bc86.png";